import { useEffect } from "react";
import { useGetClassLogDetailsQuery } from "../../../../store/api";

export function useLogDetails(logId, directLogData) {
	const {
		data: logDetailsResponse,
		isLoading,
		error,
		refetch,
	} = useGetClassLogDetailsQuery(logId, {
		skip: !logId,
	});

	useEffect(() => {
		if (logId) {
			refetch();
		}
	}, [logId, refetch]);

	const logDetails = logDetailsResponse || directLogData;

	return {
		logDetails,
		loading: isLoading,
		error,
		refetch,
	};
}
